const defaultPalette = [
  // '#51689b', '#ce5c5c', '#fbc357', '#8fbf8f', '#659d84', '#fb8e6a', '#c77288', '#786090', '#91c4c5', '#6890ba'
  // '#5470c6',
  // '#91cc75',
  // '#fac858',
  // '#ee6666',
  // '#73c0de',
  // '#3ba272',
  // '#fc8452',
  // '#9a60b4',
  // '#ea7ccc'
  '#a6cee3','#1f78b4','#b2df8a','#33a02c','#fb9a99','#e31a1c','#fdbf6f',
  '#ff7f00','#cab2d6','#6a3d9a','#ffff99','#b15928','#8dd3c7','#FF9671',
  '#FF6F91','#D65DB1','#845EC2'
];
const radiusBarPie = (data) => {
  const defaultConfig = {
    tooltip: {
      show: true,
      trigger: 'item',
      confine: true,
      padding: 3,
      borderWidth: 1,
      enterable: true,
      // textStyle: {
      //   fontSize: 2,
      //   overflow: 'breakAll'
      // },
      extraCssText: 'box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); white-space: pre-wrap;',
    },
    dataset: [
      {
        source: data,
      },
      {
        transform: [
          {
            type: 'sort',
            config: {dimension: 'value', order: 'desc'}
          }
        ]
      }

    ],
    series: [{
      type: 'pie',
      id: 'distribution',
      data: data,
      radius: ['20%','80%'],
      center: ['50%', '50%'],
      roseType: 'area',
      itemStyle: {
        color: (params) =>  defaultPalette[params.dataIndex % defaultPalette.length]
      },
      label: {
        show: true,
      },
      labelLine: {
        lineStyle: {
          type: 'dashed'
        }
      },
      datasetIndex: 1,
      animationDuration: 1000,
      animationDurationUpdate: 1000,
      universalTransition: true
    }],
    media: [
      {
        query: {
          minWidth: 1060
        },
        option: {
          series: [{
            radius: ['20%','80%'],
            label: {
              show: true,
              position: 'outer'
            },

          }],
        }
      },
      {
        query: {
          maxWidth: 1059
        },
        option: {
          series: [{
            radius: ['20%','80%'],
            label: {
              show: true,
              position: 'inner',
            },
          }],
        }
      },
      
    ]
    
  }

  const opt = Object.assign({}, defaultConfig)
  
  return opt
}

export default radiusBarPie